// extracted by mini-css-extract-plugin
export var skipAnimation = "_25-0";